export const jsonCopy = (value: any): any => JSON.parse(JSON.stringify(value))
